import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function TermsAndConditions() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, sm: 16 } }}>
      <Typography variant="h4" gutterBottom align="left">
        Terms and Conditions
      </Typography>
      <Divider sx={{ mb: 4 }} />

      {/* 1. Introduction */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          1. Introduction
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Welcome to FalconXcellence! These Terms and Conditions govern your use of our website and
          services. By accessing or using our services, you agree to be bound by these terms.
        </Typography>
      </Box>

      {/* 2. Services Provided */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          2. Services Provided
        </Typography>
        <Typography variant="body1" color="text.secondary">
          FalconXcellence provides software consulting services, including but not limited to
          full-stack development, mobile applications, cloud computing, and distributed systems. We
          aim to deliver high-quality solutions tailored to your business needs.
        </Typography>
      </Box>

      {/* 3. Responsible Usage */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          3. Responsible Usage
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Users are expected to use our services in a lawful and ethical manner. Any misuse of our
          platform, including but not limited to attempting to disrupt services or engaging in
          fraudulent activity, may result in restricted access.
        </Typography>
      </Box>

      {/* 4. Intellectual Property */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          4. Intellectual Property
        </Typography>
        <Typography variant="body1" color="text.secondary">
          All content, trademarks, and intellectual property displayed on our website are the
          property of FalconXcellence unless otherwise stated. Unauthorized reproduction or
          distribution is prohibited.
        </Typography>
      </Box>

      {/* 5. Limitation of Liability */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          5. Limitation of Liability
        </Typography>
        <Typography variant="body1" color="text.secondary">
          While we strive to provide accurate and reliable information, FalconXcellence is not
          responsible for any damages resulting from the use of our services or reliance on
          information provided on this website.
        </Typography>
      </Box>

      {/* 6. Privacy Policy */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          6. Privacy Policy
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your privacy is important to us. Please review our{' '}
          <Link
            component={RouterLink}
            to="/privacy"
            sx={{ color: 'inherit', textDecoration: 'none' }}
          >
            Privacy Policy
          </Link>{' '}
          to understand how we collect, use, and protect your data.
        </Typography>
      </Box>

      {/* 7. Changes to Terms */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          7. Changes to These Terms
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We reserve the right to modify these Terms and Conditions at any time. Changes will be
          effective upon posting, and continued use of our services implies acceptance of the
          updated terms.
        </Typography>
      </Box>

      {/* 8. Contact Information */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          8. Contact Us
        </Typography>
        <Typography variant="body1" color="text.secondary">
          If you have any questions or concerns about these Terms and Conditions, please contact us
          at{' '}
          <Link
            component="a"
            href="mailto:info@falconxcellence.com"
            sx={{ color: 'inherit', textDecoration: 'none' }}
          >
            info@falconxcellence.com
          </Link>
          .
        </Typography>
      </Box>
    </Container>
  );
}
